var map = {
	"./collect.png": "eee3",
	"./content.gif": "9d58",
	"./coupon.gif": "85a0",
	"./lesson.gif": "8758",
	"./network.gif": "53fc",
	"./order.png": "bd34",
	"./position.gif": "af82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da34";